
import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import router from './router'
// i18n
Vue.use(VueI18n)
// toastr
import  'toastr/build/toastr.min.css'
// html2canvas -- sert pour les exports de flexmonster
import html2canvas from 'html2canvas'
window.html2canvas = html2canvas
// tabs
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
Vue.use(VueTabs)

// Import des librairies communes, notamment jquery
import './assets/commun'

// JSZip est utilisé pour les exports excel. Avec un import, JSZip n'est pas chargé comme il faut, ou pas au bon moment,
// et le bouton excel ne s'affiche alors pas
window.JSZip = require('jszip')

import 'bootstrap/dist/js/bootstrap.min'
import 'admin-lte/dist/js/adminlte'

import 'datatables.net'
import 'datatables.net-bs'
import 'datatables.net-bs/css/dataTables.bootstrap.css'
import 'datatables.net-buttons-bs'
import 'datatables.net-buttons-bs/css/buttons.bootstrap.css'
import 'datatables.net-buttons/js/buttons.html5.min'
import 'datatables.net-buttons/js/buttons.flash.min'

const messages = {
    "fr-FR": require('./i18n/fr')
}
const i18n = new VueI18n({
    locale: "fr-FR",
    messages,
})
Vue.config.productionTip = false

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
